var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.docs),function(user){return _c('user-tile',{key:user._id,attrs:{"user":user}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }